/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * User Tax Entity Type
 */
export enum UserTaxEntityTypeEnum {
    INDIVIDUAL_SOLE_PROPRIETOR = 'Individual/Sole Proprietor',
    C_CORPORATION = 'C Corporation',
    S_CORPORATION = 'S Corporation',
    PARTNERSHIP = 'Partnership',
    TRUST_ESTATE = 'Trust/Estate',
    LLC = 'LLC',
    OTHER = 'Other',
}